document.addEventListener('DOMContentLoaded', function () {
    let block = document.querySelector('.unique-list');
    if (typeof Splide !== 'undefined' && block) {
        new Splide('.unique-list', {
            perPage: 3,
            gap: 20,
            padding: '0%',
            arrows: false,
            pagination: false,
            autoplay: false,

            breakpoints: {
                1024: {
                    perPage: 2,
                    padding: '5%',
                },
                768: {
                    perPage: 2,
                    padding: '5%',
                },
                600: {
                    perPage: 1,
                    padding: '20%',
                },
                500: {
                    perPage: 1,
                    padding: '10%',
                },
                450: {
                    perPage: 1,
                    padding: '0%',
                }
            }
        }).mount();
    }
});